import Reflux from 'reflux';
import EventFSObjectData from 'shared/data/EventFileSystemObject';

let async = { asyncResult: true },
  EventFolderMoveActions = Reflux.createActions({
    populate: {},
    loadFolders: async,
    loadParent: async,
    move: {},
    moveAsync: async,
    moveToPath: {},
    moveToPathAsync: async,
    submit: {},
    changeParent: {},
    goUpOneFolder: {},
  });

EventFolderMoveActions.loadFolders.listenAndPromise(
  EventFSObjectData.getFolders,
);
EventFolderMoveActions.loadParent.listenAndPromise(EventFSObjectData.getByPath);
EventFolderMoveActions.moveAsync.listenAndPromise(
  (teamId, eventId, objectIds, parentId) => {
    const move = (objId) =>
      EventFSObjectData.move(teamId, eventId, objId, parentId);

    if (!Array.isArray(objectIds)) {
      return move(objectIds);
    } else {
      return Promise.all(objectIds.map((objId) => move(objId)));
    }
  },
);
EventFolderMoveActions.moveToPathAsync.listenAndPromise(
  (teamId, eventId, objectId, parentPath, name) => {
    return EventFSObjectData.getByPath(teamId, eventId, parentPath, name).then(
      (fsObject) => {
        EventFolderMoveActions.moveAsync(
          teamId,
          eventId,
          objectId,
          fsObject._id,
        );
      },
    );
  },
);

export default EventFolderMoveActions;
